const getProjectLink = {
  methods: {
    getProjectLink(project) {
      if (project.status === 'importable' || project.status === 'errors_found') {
        return {
          name: 'import',
          params: {
            id: project.id,
          },
        };
      } else if (project.status === 'available' || project.status === 'archived') {
        return {
          name: 'summary',
          params: { id: project.id },
        };
      }
      return null;
    },
  },
};

export default getProjectLink;
